import { styled } from "@mui/material";

export const FooterContainer = styled("div")`
  background-color: white;
  padding: 3vw 3vw 0vw;/*85px 60px 0px*/ 
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 5vw 5vw;
  }
`;

export const FooterInfoSection = styled("div")`
  width: 30%;
  margin-top: auto;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom:4vw;
  }
`;
export const FooterCardContainer = styled("div")`
  display: flex;
  align-items: end;
  gap: 15px;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin: 20px auto;
  }
`;
export const FooterCard = styled("div")`
  width: 11vw;/*144px */
  ${'' /* width:144px; */}
  ${'' /* height: 200px;  */}
  height: 100%; 
  background: #FFF;
  border-radius: 5px;
  overflow: hidden;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease; 

&:hover {
  transform: scale(1.05); 
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2); 
}

  @media (max-width: 768px) {
    width: 60%;
  }
  
`;
export const FooterCardImage = styled("img")`
 width: 100%;
  object-fit: cover;
  margin: 0;
`;
export const FooterCardText = styled("div")`
  background: #1D00C4;
  color: #FFF;
  font-family: Radikal;
  font-size: 1rem;/*16px */
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  margin: 0; 
  padding: 10px;
  flex-grow: 1;
  @media (max-width: 768px) {
    font-size: 1.125rem;/*18px*/
    line-height: 20px;
    padding: 25px 10px;
  }
`;

export const FooterArrowContainer = styled("div")`
  display: flex;
  align-items: end;
  gap: 10px;
  padding-bottom:0.8vw;
  @media (max-width: 768px) {
    display: flex;
    align-items: end;  
    justify-content: flex-start;  
    padding-bottom: 0.8vw;
    width: 60%;  
  }
  `;

export const FooterCardArrow = styled("img")`
  width: 1.5vw;
  @media (max-width: 768px) {
    width: 4vw;

  }
  `;

  export const KnowMoreText = styled("a")`
  margin-top: 10px;
  font-family: Radikal;
  font-size: 1.041rem;/*16.66px */
  font-weight: 500;
  text-decoration: none;
  color: #414042;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
  &:hover {
    color: #1D00C4;
    font-weight: 600; 
    text-decoration: underline; 
    transform: scale(1.05); 
  }
`;

export const FooterTitle = styled("h3")`
  font-size: 1.492rem;/*23.88px */
  font-weight: 700;
  font-family: Radikal;
  color: #414042;
  margin-bottom: 1vw;

  @media (max-width: 1280px) {
    font-size: 1.2rem;
  }
  @media (max-width: 768px) {
    font-size:1.313rem; /*21px*/
    margin-bottom: 4vw;
  }
`;

export const FooterAddress = styled("p")`
  font-size: 1.313rem;/*21px */
  font-weight: 400;
  color: #414042;
  font-family: Radikal;
  margin-bottom: 1vw;
  padding-bottom: 1vw;
  border-bottom: 1px solid #000;
  &:last-child {
    border-bottom: none;
  }
  @media (max-width: 1280px) {
    font-size: 0.9rem;
  }
  @media (max-width: 768px) {
    font-size:0.9rem; 
    margin-bottom: 2vw;
    padding-bottom: 2vw;
  }
  @media (max-width: 480px) {
    margin-bottom: 4vw;
    padding-bottom: 4vw;
  }
  @media (max-width: 375px) {
    font-size:0.813rem; /*13px*/
    margin-bottom: 2vw;
    padding-bottom: 2vw;
  }
`;

export const FooterLinksSection = styled("div")`
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: end; 
  padding-bottom: 6vw;  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FooterLinkWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 3vw;/*41 */
  margin-top:2vw;
  @media (max-width: 1280px) {
    gap: 3vw;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const FooterMobileLinkWrapper = styled("div")`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2vw;
    width: 100%;
  }
`;

export const FooterLink = styled("a")`
  font-size: 1.492rem;/*23.88px */
  color: #414042;
  font-weight: 400;
  font-family: Radikal;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
  &:hover {
    text-decoration: underline;
    color: #1D00C4;
    transform: scale(1.02);  
  }

  @media (max-width: 1280px) {
    font-size: 1rem;
  }
  @media (max-width: 768px) {
    font-size:0.9rem; 
  }
  @media (max-width: 375px) {
    font-size: 0.938rem;/*15px */
  }
`;

export const FooterMobileLinkRow = styled("div")`
  display: flex;
  justify-content: center;
  gap: 3vw;
  margin-bottom: 2vw;
`;

export const FooterDivider = styled("span")`
  display: none;

  @media (max-width: 768px) {
    display: inline-block;
    margin: 0 2vw;
    height: 1em;
    border-left: 1px solid #231f20;
  }
`;

export const FooterImage = styled("img")`
  ${'' /* width: 340px;  */}
  width:39vw;
  padding-bottom:1vw;
  @media (max-width: 1280px) {
    width:39vw;
 
  }
  @media (max-width: 768px) {
    ${'' /* width: 60%;  */}
    width:60vw;
  }
  @media (max-width: 375px) {
    width: 60vw; 
  }
`;

export const FooterRightSection = styled("div")`
   display: flex;
  justify-content: flex-end;
  align-items: flex-end;
   margin-left: -5vw;

  @media (max-width: 768px) {
    ${'' /* width: 100%; */}
    align-items: center;
  }
`;

export const FooterBottomBar = styled("div")`
  background-color: #1D00C4;
  color: white;
  padding: 1.5vw 5vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 1vw;
    padding: 2vw 5vw;
  }
`;

export const FooterCallText = styled("p")`
  font-size: 1.894rem;/*30.31px */
  font-weight: 400;
  font-family: Radikal;
  color: #FFF;
  cursor: pointer;
  .bold-plus {
    font-weight: 600; 
  }

  .phone-number{
  transition: all 0.3s ease;
  }
  .call-colon {
    font-size: 1.9rem; 
    font-weight: 400;
  }

  .call-dot {
    font-size: 1.6rem; 
    font-weight: 400; 
  }
  .bold-plus:hover {
    text-decoration: underline;
    font-weight: 600; 

  }

  .phone-number:hover {
  font-size: 1.7rem; 
}

  @media (max-width: 1280px) {
    font-size: 1.5rem;
  }
  @media (max-width: 768px) {
    font-size: 0.938rem;/*15px */
  }
`;
export const FooterSocialText = styled("p")`
  font-size: 1.492rem;/*23.88px */
  font-weight: 400;
  font-family: Radikal;
  color: #FFF;
  align-self: center;
  @media (max-width: 1280px) {
    font-size: 1rem;/*8.26px */
  }
  @media (max-width: 768px) {
    font-size: 0.516rem;/*8.26px */
  }
`;

export const FooterSocialIcons = styled("div")`
  display: flex;
  gap: 1vw;
  align-items: flex-start;
  
`;

export const FooterSocialIcon = styled("img")`
  width: 3vw;
  height: 3vw;
  cursor: pointer;
   &:hover {
    transform: scale(1.2); 
    filter: brightness(1.2);
  }
  @media (max-width: 768px) {
    width: 5vw;
    height: 5vw;
  }

`;
